import { Autocomplete, TextField } from "@mui/material";

import { getSystemDropdownCategoryLabel } from "@/pages/system-settings/tabs/system-dropdowns/SystemDropdownsSettings.utils";
import { useSortedSystemDropdownCategories } from "@/pages/system-settings/tabs/system-dropdowns/hooks/useSortedSystemDropdownCategories";
import { useTranslation } from "@/translations";

export function CategorySelect() {
  const { t } = useTranslation();
  const { sortedCategories, selectedCategory, setSelectedCategory } = useSortedSystemDropdownCategories();

  return (
    <Autocomplete
      value={selectedCategory}
      onChange={(_, newValue) => setSelectedCategory(newValue)}
      options={sortedCategories}
      getOptionLabel={(option) => getSystemDropdownCategoryLabel(option, t)}
      disableClearable
      size="small"
      fullWidth
      renderInput={(params) => <TextField {...params} label={t("settings.systemDropdowns.selectDropdown")} />}
    />
  );
}
